import { GlobalController } from 'src/shared/global/GlobalController'
import ServiceRequestAddressUnit from './ServiceRequestAddressUnit'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: 'registration-information/unit-address',
    name:
    'serviceRequest.registration-information.unit-address',
    component: ServiceRequestAddressUnit,
    beforeEnter: ifAuthenticated,
    props: true,
    meta: {
      fillContainer: true
    }
  }

]
